import { Tooltip, TooltipProps } from 'antd';
import React, { memo } from 'react';
import { useTypedSelector } from '@hooks';
import { taskSelector } from '@redux/selectors/tasks';
import { MagicianWhiteIcon, TaskFromCommentIcon } from '@icons';

interface TaskFromCommentIconsProps {
  taskId: string;
  getPopupContainer: TooltipProps['getPopupContainer'];
}

export default memo(function TaskFromCommentIcons(
  props: TaskFromCommentIconsProps
) {
  const { taskId, getPopupContainer } = props;
  const comment = useTypedSelector(
    (state) => taskSelector(state, { taskId }).assetVersionComment
  );
  return (
    <>
      {comment?.hasAnnotations === true && (
        <Tooltip
          overlayClassName="task-group-settings-hint"
          title="This task has an annotation"
          trigger="hover"
          placement="top"
          getPopupContainer={getPopupContainer}
        >
          <MagicianWhiteIcon
            style={{
              marginRight: 12,
              cursor: 'pointer',
              fontSize: 24,
              color: '#496AFC'
            }}
          />
        </Tooltip>
      )}
      {comment?.hasAnnotations === false && (
        <Tooltip
          overlayClassName="task-group-settings-hint"
          title="This task was created from a comment"
          trigger="hover"
          placement="top"
          getPopupContainer={getPopupContainer}
        >
          <TaskFromCommentIcon style={{ marginRight: 12, cursor: 'pointer' }} />
        </Tooltip>
      )}
    </>
  );
});
